function getFileType(filename: string) {
  const paths = filename.toLowerCase().split(".");
  const extension = paths[paths.length - 1];

  if (extension === "pdf") return "application/pdf";
  else if (extension === "jpeg" || extension === "jpg") return "image/jpeg";
  else if (extension === "png") return "image/png";
}

const getPopulatedValues = (responseData: any) => {
  const comp_gst_cert = responseData.documents.find(
    (doc: any) => doc.type === "comp_gst_cert"
  );
  const comp_pan_card = responseData.documents.find(
    (doc: any) => doc.type === "comp_pan_card"
  );
  const comp_vat_cert =
    responseData.documents.find((doc: any) => doc.type === "comp_vat_cert") ||
    "";

  const lic_rvb_license = responseData.documents.find(
    (doc: any) => doc.type === "lic_rvb_license"
  );
  const lic_license_pan = responseData.documents.find(
    (doc: any) => doc.type === "lic_license_pan"
  );
  const lic_gst_cert =
    responseData.documents.find((doc: any) => doc.type === "lic_gst_cert") ||
    "";

  const bank_cancelled_cheque = responseData.documents.find(
    (doc: any) => doc.type === "bank_cancelled_cheque"
  );

  const createDocumentObject = (document: any) => ({
    name: document.fileName,
    fileType: getFileType(document.fileName),
    url: document.documentId,
    originalObj: document,
  });

  const advancePaymentMandatory = responseData.customer.advancePaymentMandatory;
  const emailActivation = responseData.customer.activationEmail ?? false;
  const step1 = {
    outletName: responseData.customer.outletName,
    companyGST: responseData.customer.companyGSTNumber,
    companyPAN: responseData.customer.companyPANNumber,
    registeredAddress: responseData.address.registeredAddress,
    authorizedSignatory: responseData.customer.companySignatoryName,
    vatNumber: responseData.customer.vatNumber,
    pincode: responseData.customer.pincode,
    emailID: responseData.customer.emailId,
    gstStateCode: responseData.customer.gstStateCode,
    comp_gst_cert: createDocumentObject(comp_gst_cert),
    comp_pan_card: createDocumentObject(comp_pan_card),
    comp_vat_cert: comp_vat_cert.fileName
      ? createDocumentObject(comp_vat_cert)
      : "",
    phoneNumber: responseData.customer.phoneNumber,
  };

  const step2 = {
    licenseName: responseData.address.licenseName,
    customerExciseRegistrationNumber:
      responseData.address.exciseRegistrationNumber,
    licensePAN: responseData.address.licensePANNumber,
    licenseGST: responseData.address?.licenseGSTNumber ?? "",
    licenseAddress: responseData.address.licenseAddress,
    gstStateCode: responseData.address.gstStateCode,
    ksbclCode: responseData.address.ksbclCode,
    lic_rvb_license: createDocumentObject(lic_rvb_license),
    lic_license_pan: createDocumentObject(lic_license_pan),
    lic_gst_cert: lic_gst_cert.fileName
      ? createDocumentObject(lic_gst_cert)
      : "",
  };

  const step3 = {
    bankName: responseData?.bank.bankName,
    bankBranch: responseData?.bank.bankBranch,
    accountType: responseData?.bank.accountType,
    accountNumber: responseData?.bank.bankAccountNumber,
    ifscCode: responseData?.bank.ifscCode,
    beneficiaryName: responseData?.bank.beneficiaryName,
    accountsDepartmentPOCName: responseData?.bank.accountsDeptPOCName,
    accountsDepartmentPOCNumber: responseData?.bank.accountsDeptPOCNumber,
    bank_cancelled_cheque: createDocumentObject(bank_cancelled_cheque),
  };

  return { advancePaymentMandatory, emailActivation, step1, step2, step3 };
};

export default getPopulatedValues;
